import { render, staticRenderFns } from "./TituloListaProdutosDoPedido.vue?vue&type=template&id=6bb91842&scoped=true"
import script from "./TituloListaProdutosDoPedido.vue?vue&type=script&lang=js"
export * from "./TituloListaProdutosDoPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb91842",
  null
  
)

export default component.exports